import angular from 'angular';
import template from './pacijent.html';
import {PacijentController} from './pacijent.controller.js';

const PacijentComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: PacijentController,
    controllerAs: 'vm'
};

export {PacijentComponent};



// WEBPACK FOOTER //
// ./app/components/pacijent/pacijent.component.js